const baseURL = process.env.REACT_APP_NIPPON_CONVOZE_BASE_API_URL;
const nipponBotApiEndpoints = {
  linkUpload: `${baseURL}/manager-panel/bot-interviews/link-upload`,
  generateReports: `${baseURL}/manager-panel/call-recording/bot-interviews/generate-reports`,
  importElevenLabs: `${baseURL}/manager-panel/call-recording/import-elevenlabs`,
  curatorDownload: `${baseURL}/manager-panel/call-recording/nippon-bot/curator/download`,
  compiledReport: `${baseURL}/manager-panel/bot-interviews/compiled-report`,
  compiledReportExport: `${baseURL}/manager-panel/bot-interviews/compiled-report/export`,
  candidateDetail: `${baseURL}/manager-panel/candidate-detail`,
  interactionsList: `${baseURL}/nippon-bot/interactions/list`,
  interactionsMisReport: `${baseURL}/nippon-bot/interactions/mis-report`,
  interactionsFilterDetails: `${baseURL}/nippon-bot/interactions/filter-details`,
  interactionDetail: `${baseURL}/nippon-bot/interactions`,
  transcriptionDetail: `${baseURL}/nippon-bot/transcriptions`,
  audioInsight: `${baseURL}/nippon-bot/transcriptions/audio-insight`,
  callAdherence: `${baseURL}/nippon-bot/call-adherence`,
  resumeUpload: `${baseURL}/nippon-bot/resumes/upload`,
  resumeList: `${baseURL}/nippon-bot/resumes`,
  resumeDetail: `${baseURL}/nippon-bot/resumes`,
  candidateCreate: `${baseURL}/nippon-bot/candidates`,
  candidateList: `${baseURL}/nippon-bot/candidates`,
  candidateProfileDetail: `${baseURL}/nippon-bot/candidates`,
  candidateUpdate: `${baseURL}/nippon-bot/candidates`,
  candidateDelete: `${baseURL}/nippon-bot/candidates`,
  resumeDownload: `${baseURL}/nippon-bot/resumes`,
  assignInterviewCandidate: `${baseURL}/nippon-bot/interviews/assign-candidate`,
  schedulingCandidates: `${baseURL}/nippon-bot/interviews/candidates/search`,
  elevenLabsAgents: `${baseURL}/nippon-bot/interviews/elevenlabs-agents`,
  outboundSchedules: `${baseURL}/nippon-bot/interviews/schedules`,
  branchManagerCandidateCreate: `${baseURL}/nippon-bot/branch-manager/candidates`,
  branchManagerCandidateList: `${baseURL}/nippon-bot/branch-manager/candidates`,
  branchManagerCandidateDetail: `${baseURL}/nippon-bot/branch-manager/candidates`,
  branchManagerCandidateUpdate: `${baseURL}/nippon-bot/branch-manager/candidates`,
  branchManagerResumeUpload: `${baseURL}/nippon-bot/branch-manager/resumes/upload`,
  branchManagerInterviewAgents: `${baseURL}/nippon-bot/branch-manager/interview-agents`,
  branchManagerInterviewCreate: `${baseURL}/nippon-bot/branch-manager/interviews`,
  branchManagerInterviewRetryFailed: `${baseURL}/nippon-bot/branch-manager/interviews`,
  branchManagerAccountCreate: `${baseURL}/nippon-bot/branch-manager-accounts`,
  branchManagerAccountList: `${baseURL}/nippon-bot/branch-manager-accounts`,
  branchManagerAccountUpdate: `${baseURL}/nippon-bot/branch-manager-accounts`,
  branchManagerAccountDelete: `${baseURL}/nippon-bot/branch-manager-accounts`
};

export default nipponBotApiEndpoints;
